import dom from '../../../wrapper/DomWrapper';

export default (element) => {
  if (!element) return;

  dom.removeClass(element, ['right', 'left', 'center', '_right', '_left', '_center']);
};
